export default function ConversationListEmpty() {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center"
      role="status"
    >
      <div className="flex h-[129px] w-[144px] flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-start gap-2" aria-hidden>
          <div className="h-[10px] w-[50px] bg-default-200" />
          <div className="h-[6px] w-[100px] bg-default-100" />
          <div className="h-[6px] w-[80px] bg-default-100" />
        </div>
        <p className="text-center text-xs font-medium leading-4 text-default-300">
          未找到对话
        </p>
      </div>
    </div>
  );
}
